import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import RelocationBanner from "@/components/RelocationBanner";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import WhyChooseUs from "@/components/WhyChooseUs";
import CostCalculator from "@/components/CostCalculator";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import CitiesGrid from "@/components/CitiesGrid";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ScrollToTop from "@/components/ScrollToTop";
import CityPage from "@/pages/CityPage";
import AdminAnalytics from "@/pages/AdminAnalytics";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-brand-cream text-brand-navy">
      <Header />
      <main>
        <Hero />
        <RelocationBanner />
        <Marquee />
        <HowItWorks />
        <WhyChooseUs />
        <CostCalculator />
        <Pricing />
        <Testimonials />
        <CitiesGrid />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/shipping-to/:slug" element={<CityPage />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
          </Routes>
          <WhatsAppFloat />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
